<template>
  <v-container>
    <app-city-header :payload="payload"> </app-city-header>

    <v-row>
      <v-col sm="3">
        <app-meeting-combobox :filter="payload" @onChange="setReportName">
        </app-meeting-combobox>
      </v-col>

      <v-col sm="3">
        <v-text-field
          v-model="payload.encontro.inicioString"
          v-mask="'##/##/####'"
          :label="`Data ${isAT ? 'da Agenda' : 'do Encontro'}`"
          readonly
        ></v-text-field>
      </v-col>

      <v-col sm="3">
        <v-combobox
          v-model="payload.tipoExecucaoRelatorio"
          :items="tiposExecucao"
          label="Execução"
          item-text="text"
          item-value="value"
          :required="true"
        >
        </v-combobox>
      </v-col>

      <v-col sm="2" offset-sm="1" class="text-right">
        <v-btn outlined color="primary" class="ml-3" @click="save()">
          <span>Finalizar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col sm="3">
        <v-text-field
          v-model="payload.inicioString"
          v-mask="'##/##/#### ##:##'"
          label="Data de Início"
          placeholder="00/00/0000 00:00"
          disabled
        ></v-text-field>
      </v-col>

      <v-col sm="3">
        <v-text-field
          v-model="payload.fimString"
          v-mask="'##/##/#### ##:##'"
          label="Data de Término"
          placeholder="00/00/0000 00:00"
          disabled
        ></v-text-field>
      </v-col>

      <v-col sm="3">
        <v-text-field
          :required="true"
          v-restrict.number
          v-model="payload.horasUtilizadasString"
          label="Horas Utilizadas"
          placeholder="0"
          persistent-hint
          :disabled="
            !isFullAdmin &&
            !config.editaHorasUtilizadas &&
            !groupsConfig.editaHorasUtilizadas
          "
        ></v-text-field>
      </v-col>
      <v-col
        style="display: flex; align-items: center"
        v-if="
          isFullAdmin ||
          (config.verParcialAcaoFinalizada &&
            groupsConfig.verParcialAcaoFinalizada)
        "
      >
        <strong>Tipo {{ isAT ? "da Agenda" : "do Encontro" }}:</strong>
        <span class="ml-2">{{ payload.encontro.encontroType }}</span>
      </v-col>
    </v-row>
    <v-row
      v-if="
        isFullAdmin ||
        (config.exibirPjAtendida && groupsConfig.exibirPjAtendida) ||
        (config.exibirPfAtendida && groupsConfig.exibirPfAtendida)
      "
    >
      <v-col sm="3">
        <v-text-field
          v-if="
            isFullAdmin ||
            (config.exibirPfAtendida && groupsConfig.exibirPfAtendida)
          "
          v-restrict.number
          v-model="payload.pjAtendidas"
          label="Pessoas Físicas Atendidas"
          placeholder="0"
          persistent-hint
        ></v-text-field>
      </v-col>
      <v-col sm="3">
        <v-text-field
          v-if="
            isFullAdmin ||
            (config.exibirPjAtendida && groupsConfig.exibirPjAtendida)
          "
          v-restrict.number
          v-model="payload.pfAtendidas"
          label="Empresas Atendidas"
          placeholder="0"
          persistent-hint
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-tabs vertical>
        <v-tab>
          <v-icon left>mdi-file-chart</v-icon>
          Relatório
        </v-tab>
        <v-tab>
          <v-icon left>mdi-account-multiple-plus</v-icon>
          Convidados
        </v-tab>
        <v-tab>
          <v-icon left>mdi-attachment</v-icon>
          Anexos
        </v-tab>
        <v-tab>
          <v-icon left>mdi-attachment</v-icon>
          {{ isAT ? "Iniciativas" : "Tarefas" }}
        </v-tab>
        <v-tab>
          <v-icon left>mdi-android-messages</v-icon>
          Observações
        </v-tab>

        <v-tab-item>
          <v-col>
            <v-textarea
              label="Relatório do evento"
              required
              v-model="payload.descricao"
            ></v-textarea>
          </v-col>
        </v-tab-item>
        <v-tab-item>
          <v-col>
            <app-modal-insert-member
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :municipioId="payload.municipioId"
              :grupo="payload.encontro.grupo"
              @onSave="getMembers"
            >
              <template v-slot:title :edit="false"> Cadastrar Membro </template>
            </app-modal-insert-member>
          </v-col>

          <v-col>
            <v-combobox
              v-model="payload.convidadosRelatorio"
              :items="membros"
              chips
              clearable
              label="Membros"
              item-text="nome"
              item-value="membroId"
              multiple
            >
              <template v-slot:selection="{ attrs, item }">
                <v-chip close @click:close="removeMembro(item)">
                  <strong>{{ item.nome }} - {{ item.cpf }}</strong>
                </v-chip>
              </template>
            </v-combobox>
          </v-col>
          <v-data-table
            :headers="headersConvidados"
            :items="payload.convidadosRelatorio"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.presente="{ item }">
              <v-checkbox
                v-model="item.presente"
                :id="'membro' + item.membroId"
                color="primary"
              >
              </v-checkbox>
            </template>

            <template slot="no-data">
              <span> Nenhum convidado adicionado </span>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-col>
            <template>
              <v-file-input
                multiple
                label="File input"
                v-model="payload.currArquivos"
                @change="inputChanged"
              >
              </v-file-input>
              <div v-if="payload.arquivos.length">
                <h5>Total Arquivos</h5>
                <v-chip @click="removeAllFiles" class="mr-5">
                  {{ payload.arquivos.length }}
                </v-chip>
              </div>
            </template>
          </v-col>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :headers="headers"
            :items="payload.tarefasRelatorio"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.cumprida="{ item }">
              <v-checkbox
                v-model="item.cumprida"
                :id="'cumprida' + item.tarefaId"
                color="primary"
                :disabled="true"
              >
              </v-checkbox>
            </template>

            <template
              v-slot:item.tarefa.municipioTarefa.municipioEvidencias="{ item }"
            >
              <span
                v-for="evidencia in item.municipioTarefa.municipioEvidencias"
                :key="evidencia.municipioEvidenciaId"
              >
                {{ evidencia.nome }} |
              </span>
            </template>

            <template slot="no-data">
              <span> Nenhuma tarefa retornada </span>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-col>
            <v-textarea v-model="payload.observacoes"></v-textarea>
          </v-col>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import { memberAPI } from "@/modules/city/components/MemberAPI";
import { reportAPI } from "@/modules/report";
import { mapActions, mapGetters } from "vuex";
import { AppMeetingCombobox } from "@/modules/calendar";
import AppModalInsertTask from "./ModalInsertTask";
import { AppCityHeader } from "@/modules/city";
import AppModalInsertMember from "@/modules/city/components/group/ModalInsertMember";

export default {
  components: {
    AppMeetingCombobox,
    AppModalInsertTask,
    AppCityHeader,
    AppModalInsertMember,
  },
  data() {
    return {
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      tiposExecucao: [
        { text: "Presencial", value: 1 },
        { text: "Remoto", value: 2 },
      ],
      payload: {
        arquivos: [],
        currArquivos: [],
        convidadosRelatorio: [],
        descricao: null,
        encontroId: 0,
        municipioId: this.$route.params.id,
        titulo: null,
        tarefasRelatorio: [],
        observacoes: null,
        encontro: {
          inicioString: null,
        },
      },
      membros: [],
      headers: [
        { text: "Tarefa", value: "municipioTarefa.nome" },
        { text: "Horas", value: "municipioTarefa.horas" },
        { text: "Cumprida", value: "cumprida" },
        {
          text: "Evidências",
          value: "tarefa.municipioTarefa.municipioEvidencias",
        },
      ],
      headersConvidados: [
        { text: "Nome", value: "nome" },
        { text: "CPF", value: "cpf" },
        { text: "E-mail", value: "email" },
        { text: "Presente", value: "presente" },
      ],
      estado: this.$store.state.uf,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    save() {
      if (!this.payload.descricao) {
        this.$notification.error(
          `É necessário preencher o relatório do evento`
        );
        return;
      }
      if (!this.payload.encontroId || this.payload.encontroId === 0) {
        this.$notification.error(
          `${this.isAT ? "A agenda" : "O encontro"} deve estar preenchido`
        );
        return;
      }
      if (
        (this.estado === "SC" ||
          this.estado === "MS" ||
          this.estado === "BA" ||
          this.estado === "SP" ||
          this.estado === "MA" ||
          this.estado === "RJ") &&
        !this.payload.tipoExecucaoRelatorio
      ) {
        this.$notification.error("O tipo de execução deve estar preenchido");
        return;
      } else if (
        (this.estado === "SC" ||
          this.estado === "MS" ||
          this.estado === "BA" ||
          this.estado === "SP" ||
          this.estado === "MA" ||
          this.estado === "RJ") &&
        !this.payload.horasUtilizadasString
      ) {
        this.payload.horasUtilizadasString = "0";
      } else {
        this.setLoading(true);
        let formData = new FormData();

        for (let i = 0; i < this.payload.arquivos.length; i++) {
          formData.append("arquivos", this.payload.arquivos[i]);
        }

        formData.append(
          "convidadosRelatorioString",
          JSON.stringify(this.payload.convidadosRelatorio)
        );
        formData.append(
          "tarefasRelatorioString",
          JSON.stringify(this.payload.tarefasRelatorio)
        );
        formData.append("descricao", this.payload.descricao);
        formData.append("encontroId", this.payload.encontroId);
        formData.append("municipioId", this.payload.municipioId);
        formData.append("titulo", this.payload.titulo);
        if (this.payload.pjAtendidas) {
          formData.append("pjAtendidas", this.payload.pjAtendidas);
        }
        if (this.payload.pfAtendidas) {
          formData.append("pfAtendidas", this.payload.pfAtendidas);
        }
        if (this.payload.tipoExecucaoRelatorio) {
          formData.append(
            "tipoExecucaoRelatorioId",
            this.payload.tipoExecucaoRelatorio.value
          );
        } else {
          formData.append("tipoExecucaoRelatorioId", 1);
        }
        if (this.payload.horasUtilizadasString) {
          formData.append(
            "horasUtilizadasString",
            this.payload.horasUtilizadasString
          );
        }
        formData.append("inicioString", this.payload.inicioString);
        formData.append("fimString", this.payload.fimString);
        if (this.payload.observacoes) {
          formData.append("observacoes", this.payload.observacoes);
        }
        if (this.payload.motivoRejeicao) {
          formData.append("motivoRejeicao", this.payload.motivoRejeicao);
        }
        if (this.payload.complemento) {
          formData.append("complemento", this.payload.complemento);
        }

        reportAPI
          .create(formData)
          .then((resp) => {
            this.$notification.success("Relatório salvo com sucesso");
            this.$router.push(
              "/cidade/" + this.payload.municipioId + "/relatorio"
            );
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao salvar relatório");
          });
      }
    },
    setReportName(meetings, encontroId) {
      this.setLoading(true);
      this.payload.encontro = meetings.find(
        (item) => item.encontroId === encontroId
      );
      console.log(" this.payload: ", this.payload);

      this.payload.titulo = this.payload.encontro.grupoData;
      this.payload.encontroId = this.payload.encontro.encontroId;
      this.payload.convidadosRelatorio = this.payload.encontro.convidadosEvento;
      this.payload.tarefasRelatorio = [];
      this.payload.inicioString = this.payload.encontro.inicioString;
      this.payload.fimString = this.payload.encontro.fimString;
      this.payload.horasUtilizadasString = this.payload.encontro.tarefas.reduce(
        function (a, b) {
          return a + b.municipioTarefa.horas;
        },
        0
      );

      for (
        let count = 0;
        count < this.payload.encontro.tarefas.length;
        count++
      ) {
        this.payload.tarefasRelatorio.push({
          municipioTarefa: this.payload.encontro.tarefas[count].municipioTarefa,
          municipioTarefaId:
            this.payload.encontro.tarefas[count].municipioTarefaId,
          cumprida: true,
        });
      }

      for (
        let count = 0;
        count < this.payload.convidadosRelatorio.length;
        count++
      ) {
        this.payload.convidadosRelatorio[count].presente = true;
      }

      this.getMembers();
    },
    getMembers() {
      this.setLoading(true);
      memberAPI
        .getMembersByCity(this.payload.municipioId)
        .then((resp) => {
          this.membros = resp.data;
          this.onMemberClick();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter membros");
        });
    },
    addTask(tasks) {
      for (let count = 0; count < tasks.length; count++) {
        this.payload.tarefasRelatorio.push({
          municipioTarefa: tasks[count],
          municipioTarefaId: tasks[count].municipioTarefaId,
          cumprida: true,
        });
      }
    },
    onMemberClick() {
      for (let count = 0; count < this.membros.length; count++) {
        this.membros[count].presente = true;
      }
    },
    inputChanged() {
      this.payload.currArquivos.map((e) => {
        this.payload.arquivos.push(e);
      });
    },
    removeAllFiles() {
      this.payload.arquivos = [];
      this.payload.currArquivos = [];
    },
  },
  computed: {
    ...mapGetters(["loading", "isFullAdmin", "isAT"]),
  },
};
</script>
